import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';  // Um auf location.state zuzugreifen
import CustomNavbar from '../CustomNavbar';
import MemberList from './zrMemberList';
import cfg from '../../config';

const ZRMember = () => {
    const [firstName, setFirstName] = useState('');
    const location = useLocation(); // Um die message aus der URL zu bekommen

    useEffect(() => {
        // Setze die bg-dark Klasse für den body
        document.body.classList.add('bg-dark');

        // Werte aus dem localStorage abrufen
        const storedFirstName = localStorage.getItem('firstName');
        const storedLastName = localStorage.getItem('lastName');
        setFirstName(storedFirstName || ''); // Fallback falls null

    }, []);

    return (
        <div>
            <CustomNavbar /> {/* Navbar oben anzeigen */}
            <div className="container mt-4">
                <h1>Willkommen im Bereich {cfg.adminRoleName}, {firstName}!</h1>
                
                {/* Anzeige der Nachricht, wenn sie existiert */}
                {location.state && location.state.message && (
                    <div className="alert alert-warning">
                        {location.state.message}
                    </div>
                )}
            </div>
            <div>
                <MemberList/>
            </div>
            <br/>
            <br/>
        </div>
    );
};

export default ZRMember;
